export default __webpack_public_path__ + "media/images/images/jvqmap/marker/purple-73ebe9a954de599e2249351434b8a88e.png";